"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var manager_slave_1 = require("@wix/bsi-manager/dist/src/manager-slave");
var consent_policy_client_accessor_1 = require("@wix/consent-policy-client-accessor");
var BsiManagerKey = '__bsiManager';
var createBsiManager = function (Wix) {
    var Utils = Wix.Utils;
    var policyAccessor = new consent_policy_client_accessor_1.ConsentPolicyAccessor();
    var callSafe = function (fn) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        return Utils.commonConfig &&
            typeof Utils.commonConfig[fn] === 'function' && (_a = Utils.commonConfig)[fn].apply(_a, args);
    };
    return new manager_slave_1.SlaveBsiManager()
        .init({
        getCommonConfig: function () { return ({
            get: function (key) { return callSafe('get', key); },
            subscribe: function (handler) { return callSafe('onCommonConfigChanged', handler); }
        }); },
        getConsentPolicy: function () { return ({ policy: policyAccessor.getCurrentConsentPolicy() }); }
    }, { enableCookie: true });
};
exports.initBsiManager = function () {
    if (typeof window === 'undefined' || !window.Wix) {
        return null;
    }
    if (!window[BsiManagerKey]) {
        window[BsiManagerKey] = {
            manager: createBsiManager(window.Wix),
            getBsi: function () {
                // tslint:disable: no-invalid-this
                var Analytics = window.Wix.Analytics;
                if (Analytics && typeof Analytics.reportVisitorActivity === 'function') {
                    Analytics.reportVisitorActivity();
                }
                return this.manager.getBsi();
            }
        };
    }
    return window[BsiManagerKey];
};
//# sourceMappingURL=bsi.js.map